<template>
  <ScrollAwareContainer class="StoryScreen">
    <CalloutTitle
      data-testid="title"
      tag="h2"
      size="XLarge"
      :callouts="titleCallouts"
      v-bind="{title}"
      :style="{
        '--backgroundColor': titleCalloutColor,
      }"
    />

    <figure
      v-if="$slots.figure"
      class="StoryScreen__figure"
      data-testid="figure"
    >
      <slot name="figure" />
    </figure>

    <UIText
      data-testid="body"
      tag="div"
      size="Medium"
      isMultiline
    >
      <div
        v-html="formattedBody"
      />
    </UIText>

    <slot />
  </ScrollAwareContainer>
</template>

<script lang="ts" setup>
import ScrollAwareContainer from "@cosine/components/ScrollAwareContainer.vue";
import CalloutTitle from "@cosine/components/CalloutTitle.vue";
import UIText from "@cosine/components/UIText.vue";
import { marked } from "marked";
import { computed } from "vue";

const {
  body,
  titleCallouts = [],
  titleCalloutColor,
} = defineProps<{
  title: string,
  body: string,
  titleCallouts?: Array<string>,
  titleCalloutColor?: string,
}>();

const formattedBody = computed(() => {
  return marked(body);
});
</script>

<style lang="scss" scoped>
.StoryScreen {
  display: grid;
  gap: 24px;
  align-content: start;
  margin: 0 calc(-1 * var(--layoutMargin));
  padding: 0 var(--layoutMargin);

  &.v-enter-active,
  &.v-leave-active {
    position: absolute;
    inset: 0;

    transition: 500ms var(--easeInOutCubic);
    transition-property: opacity, transform;
  }

  &.v-enter-from,
  &.v-leave-to {
    opacity: 0;
  }

  [data-direction="forward"] &.v-enter-from,
  [data-direction="backward"] &.v-leave-to {
    transform: translateX(20%);
  }

  [data-direction="backward"] &.v-enter-from,
  [data-direction="forward"] &.v-leave-to {
    transform: translateX(-20%);
  }
}

.StoryScreen__figure:empty {
  display: none;
}
</style>
